import { createContext, useEffect, useState } from "react";
import { BookOpen, ClipboardList, Dumbbell, MoveRight, Clock, FileCheck, FileX, CircleDot, } from 'lucide-react';
import axios from "axios";
import moment from "moment";


export const ProgramContext = createContext({})

export function ProgramContextProvider({ children }) {

    const [isTemplate, setIsTemplate] = useState(false)
    const [programId, setProgramId] = useState(undefined)
    const [headerData, setHeaderData] = useState(
        {
            patientId: 0,
            patientName: '',
            problemArea: '',
            problemId: 0,
            protocol: '',
            subtype: '',
            subtypeId: 0,
            cpgProtocol: '',
            cpgProtocolId: 0,
            status: 'Unassigned',
            startDate: moment().format('YYYY-MM-DD'),
            planLength: 0,
            totalReward: 0,
            programName: "",
            saveTemplate: false,
            templateId: true,
            is_in_progress: 1
        }
    );
    const [plan, setPlan] = useState(null);
    const [problemAreas, setProblemAreas] = useState([]);
    const [cpgProtocols, setCpgProtocols] = useState([]);
    const [subProblems, setSubProblems] = useState([]);
    const [patients, setPatients] = useState([]);
    const [ptSessions, setPtSessions] = useState([]);
    const [educationTasks, setEducationTasks] = useState([]);
    const [educationList, setEducationList] = useState([])
    const [questionsTasks, setQuestionsTasks] = useState([]);
    const [questionsList, setQuestionsList] = useState([]);
    const [exerciseTemplates, setExerciseTemplates] = useState([]);
    const [initialPlan, setInitialPlan] = useState(null);
    const [checkDataLoaded, setCheckDataLoaded] = useState({
        patients: false,
        ptSessions: false,
        problemAreas: false,
        subProblems: false,
        cpgProtocols: false
    })
    const [programTemplates, setProgramTemplates] = useState([]);
    const [loadingTemplates, setLoadingTemplates] = useState(false)
    // ---------- ALL CPG PROTOCOLS AND SUBPROBLEMS ------------
    const [allCpgProtocols, setAllCpgProtocols] = useState([])
    const [allSubProblems, setAllSubProblems] = useState([])

    useEffect(() => {
        if (headerData?.problemId && headerData?.problemId !== 0 && allCpgProtocols?.length > 0) {
            setCpgProtocols(allCpgProtocols?.filter((e) => e?.problem_id === headerData?.problemId))
        }
        if (headerData?.cpgProtocolId && headerData?.cpgProtocolId !== 0 && allSubProblems?.length > 0) {
            setSubProblems(allSubProblems?.filter((e) => e?.clinical_protocol_id === headerData?.cpgProtocolId))
        }
    }, [
        allCpgProtocols,
        allSubProblems,
        headerData?.problemId,
        headerData?.cpgProtocolId,
    ])


    useEffect(() => {
        async function fetchProgramTemplates() {
            setLoadingTemplates(true)
            axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
            axios
                .post(window.ajaxLink + "cloud_programs/all-programs", {
                    search: "",
                    selectedTab: "Templates",
                })
                .then((res) => {
                    if (res.data.responseData) {
                        var templates = [];
                        const filteredTemplates = res.data.responseData?.filter((e) => e.is_in_progress === 0)
                        for (var item of filteredTemplates) {
                            var vals = { value: item.program_name, key: item.id };
                            templates.push(vals);
                        }
                        setProgramTemplates(templates);
                    }
                })
                .catch((error) => {
                    console.log(error);
                }).finally(() => setLoadingTemplates(false));
        }

        fetchProgramTemplates()
    }, []);

    useEffect(() => {
        var userData = JSON.parse(localStorage.getItem("userData"));
        if (userData) {
            // FETCH PATIENT NAMES
            async function fetchPatientNames() {
                axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
                axios
                    .post(window.ajaxLink + "cloud_programs/edit-details", {
                        problem_id: headerData?.problemId,
                        clinical_protocol_id: headerData?.cpgProtocolId,
                        patient_search: "",
                    })
                    .then((res) => {
                        if (res.data.responseData) {
                            var respState = function (stateName, inx) {
                                if (stateName === setPatients && res.data.responseData[inx].length > 0) {
                                    res.data.responseData[inx].unshift({ value: null, key: null });
                                }
                                stateName(res.data.responseData[inx]);

                                if (stateName === setPatients) {
                                    setCheckDataLoaded((prev) => ({ ...prev, patients: true }))
                                } else if (stateName === setProblemAreas) {
                                    setCheckDataLoaded((prev) => ({ ...prev, problemAreas: true }))
                                } else if (stateName === setAllSubProblems) {
                                    setCheckDataLoaded((prev) => ({ ...prev, subProblems: true }))
                                }
                                else if (stateName === setAllCpgProtocols) {
                                    setCheckDataLoaded((prev) => ({ ...prev, cpgProtocols: true }))
                                }
                                else if (stateName === setEducationList) {
                                    setEducationTasks(prev => prev.map((e, index) => ({ ...e, ...res.data.responseData[inx][index] })))
                                } else if (stateName === setQuestionsTasks) {
                                    setQuestionsList(prev => prev.map((e, index) => ({ ...e, ...res.data.responseData[inx][index] })))
                                }
                            };
                            respState(setPatients, 0);
                            respState(setProblemAreas, 1);
                            respState(setAllSubProblems, 2);
                            respState(setEducationTasks, 3);
                            respState(setEducationList, 4);
                            respState(setQuestionsList, 6);
                            respState(setQuestionsTasks, 5);
                            respState(setAllCpgProtocols, 7);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
            }

            // FETCH WORKOUT DATA
            async function fetchPtSessions() {
                axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
                axios
                    .post(window.ajaxLink + "tasks/get-all-workouts", { search: "" })
                    .then((res) => {
                        if (res.data.responseData) {
                            var allWorkouts = [];
                            for (var singleWorkout of res.data.responseData) {
                                singleWorkout.value = singleWorkout.name;
                                allWorkouts.push(singleWorkout);
                            }
                            setPtSessions(allWorkouts);
                            setCheckDataLoaded((prev) => ({ ...prev, ptSessions: true }))
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
            }

            // FETCH EXERCISE TEMPLATES
            async function fetchExerciseTemplates() {
                axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
                axios
                    .post(window.ajaxLink + "cloud_programs/get-exercise-templates", {
                        search: "",
                        problemId: headerData?.problemId,
                        isROM: 0,
                        exerciseData: []
                    })
                    .then((res) => {
                        if (res.data.responseData) {
                            let response = res.data.responseData.exerciseData;
                            const sort = response.sort((a, b) => a.is_portrait - b.is_portrait);
                            setExerciseTemplates(sort?.map((e) => ({ ...e, ...e?.exercise_data, equipment_id: e?.exercise_data?.equipment_id, equipment_name: e?.exercise_data?.equipment_name, set_id: generateUniqueId() })))
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }

            fetchPatientNames()
            if (!checkDataLoaded.ptSessions) {
                fetchPtSessions()
            }
            fetchExerciseTemplates()
        }
    }, [headerData?.problemId, headerData?.cpgProtocolId, headerData?.subtypeId]);

    useEffect(() => {
        if (headerData?.patientName && !headerData?.problemArea) {
            setHeaderData(prev => ({ ...prev, problemArea: problemAreas[0]?.value }))
        }
    }, [headerData?.patientName, problemAreas])


    useEffect(() => {
        if (headerData?.problemArea !== "") {
            setHeaderData(prev => ({ ...prev, problemId: problemAreas?.find((e) => e?.value === headerData?.problemArea)?.key }))
        }
    }, [headerData?.problemArea, problemAreas])


    useEffect(() => {
        if (headerData?.cpgProtocol !== "" && cpgProtocols?.length > 0) {
            setHeaderData(prev => ({ ...prev, cpgProtocolId: cpgProtocols?.find((e) => e?.value === headerData?.cpgProtocol)?.key }))
        }
    }, [headerData?.cpgProtocol, cpgProtocols])


    useEffect(() => {
        if (headerData?.subtype !== "" && subProblems?.length > 0) {
            setHeaderData(prev => ({ ...prev, subtypeId: subProblems?.find((e) => e?.value === headerData?.subtype)?.key }))
        }
    }, [headerData?.subtype, subProblems])

    // console.log("cpgProtocols", cpgProtocols)

    // --- MOCK API & DATA ---
    const mockApi = {
        fetchPatients: async (query) => {
            if (!query) return patients;
            return patients
                .filter(p => p.value && p.value.toLowerCase().includes(query.toLowerCase()))
            // .map(p => p.value);
        },
        fetchProblemAreaData: async () => {
            const data = {};

            problemAreas.forEach((problem) => {
                data[problem.value] = {
                    problem_id: problem.key,
                    protocols: allCpgProtocols?.filter((e) => e?.problem_id === problem.key)?.reduce((acc, sub) => {
                        acc[sub.value] = [sub.value];
                        return acc;
                    }, {}),
                    subProblems: subProblems?.reduce((acc, sub) => {
                        acc[sub.value] = [sub.value];
                        return acc;
                    }, {}),
                    romTests: [
                        {
                            id: `rom_${problem.value.toLowerCase().replace(/\s+/g, '_')}_all`,
                            name: `Full ${problem.value} ROM Assessment`,
                            exercises: exerciseTemplates?.map((e) => ({
                                ...e,
                                id: e?.exerciseId,
                                hasHold: e?.exercise_data?.hold_in_seconds > 0,
                                hasSide: "Leg",
                                videoUrl: e?.exercise_data?.video,
                                hold_in_seconds: e?.exercise_data?.hold_in_seconds || 0,
                                set_limb_instruction: e?.limb_instructions?.length ? e?.limb_instructions[0] : "",
                                limb: e?.limb_instructions ? "Y" : "N",
                            })),
                        },
                    ],
                    functionalQuestionnaires: [],
                };
            });

            return data;
        },
        fetchActivityLibrary: async () => ({
            ptSessions:
                ptSessions?.map(e => ({
                    ...e,
                    type: "PT_SESSION",
                    title: e.name,
                    estTime: e.duration,
                    exerciseCount: e.activities?.length || 0
                })) || []
            ,
            education:
                educationTasks?.map((e, index) => ({
                    ...e,
                    id: index,
                    type: "EDUCATION",
                    category: "Article",
                    title: e?.value,
                    readTime: e?.duration,
                    content: "",
                    url: e?.url,
                    duration: e?.duration
                })),
            generalQuestionnaires:
                questionsList?.map((e) => ({
                    ...e,
                    id: e?.question_id,
                    title: e?.name,
                    estTime: e?.duration,
                    type: "QUESTIONNAIRE",
                    category: "General",
                }))

        })
        ,
        fetchExerciseLibrary: async () => (
            exerciseTemplates?.map((e, index) => ({
                ...e,
                id: e?.exerciseId,
                // name: e?.name,
                subtype: e?.exercise_data?.exercise_type,
                position: e?.exercise_data?.exercise_position
                    ?
                    `${e?.exercise_data?.exercise_position}` :
                    e?.is_portrait === 0
                        ? "Floor"
                        : e?.name.split(" ")[0] === "Seated"
                            ? "Seated"
                            : "Standing",
                toCamera: 'At Camera',
                bodyPosition: 'Facing Right',
                limb: e?.limb_instructions ? "Y" : "N",
                videoUrl: e?.exercise_data?.video,
                target_rom_max: "100%",
            }))
        )
    };

    // --- HELPER DATA & FUNCTIONS ---

    const ACTIVITY_TYPES = { PT_SESSION: { name: 'PT Session', icon: Dumbbell, color: 'blue' }, ROM_TEST: { name: 'ROM Test', icon: MoveRight, color: 'green' }, EDUCATION: { name: 'Education', icon: BookOpen, color: 'purple' }, QUESTIONNAIRE: { name: 'Questionnaire', icon: ClipboardList, color: 'yellow' }, };
    const ACTIVITY_STATES = { SCHEDULED: { name: 'Scheduled', icon: CircleDot, color: 'gray' }, PENDING: { name: 'Pending', icon: Clock, color: 'yellow' }, COMPLETED: { name: 'Completed', icon: FileCheck, color: 'green' }, INCOMPLETE: { name: 'Incomplete', icon: FileX, color: 'red' }, };
    const today = new Date();
    today.setUTCHours(11, 22, 3, 623)
    const ensureDateObject = (date) => (typeof date === 'string' ? new Date(date) : date);
    const getStartOfWeek = (date) => {
         const start = new Date(ensureDateObject(date));
         start.setUTCHours(11, 22, 3, 623)
         const day = start.getDay(); 
         const diff = start.getDate() - day + (day === 0 ? -6 : 1); 
         const returningDate = new Date(start.setDate(diff));
        return returningDate.setUTCHours(11, 22, 3, 623)
        };
    const addDays = (date, days) => { 
        const result = new Date(ensureDateObject(date)); 
        result.setUTCHours(11, 22, 3, 623);
        result.setDate(result.getDate() + days); 
        return result; };
    const formatDate = (date) => { 
        const d = ensureDateObject(date); 
        d.setUTCHours(11, 22, 3, 623);
        if (!d || isNaN(d.getTime())) 
            return "Invalid Date"; 
        return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    const isSameDay = (d1, d2) => { 
        const d_1 = ensureDateObject(d1); 
        d_1.setUTCHours(11, 22, 3, 623);
        const d_2 = ensureDateObject(d2); 
        d_2.setUTCHours(11, 22, 3, 623);
        if (!d_1 || !d_2 || isNaN(d_1.getTime()) || isNaN(d_2.getTime())) return false; 
        return d_1.getFullYear() === d_2.getFullYear() && d_1.getMonth() === d_2.getMonth() && d_1.getDate() === d_2.getDate(); };
    const isPast = (date) => { 
        const d = ensureDateObject(date);
        const currentDate = new Date(); // Get current date each time
        
        const dStr = d.toLocaleDateString();
        const currentStr = currentDate.toLocaleDateString();
        
        const dCompare = new Date(dStr);
        const currentCompare = new Date(currentStr);
        return dCompare < currentCompare;
    }
    const generateUniqueId = () => `id_${new Date().getTime()}_${Math.random().toString(36).substr(2, 9)}`;

    function convertSideExercisesToActivities(inputExercises, programTaskId = 0) {
        return inputExercises.map((exercise, index) => {
            const data = exercise.exercise_data || {};

            return {
                ...exercise,
                id: Date.now() + index,
                activity_id: exercise.activity_id || exercise.exerciseId || exercise.id || 0, // preserve existing
                display_name: exercise.name || exercise.display_name || data.display_name || '',
                duration: exercise.duration || data.duration || 0,
                duration_type: exercise.duration_type || data.duration_type || 'Reps',
                // rom_minimum: exercise.rom_minimum || data.rom_minimum || 0,
                reps: exercise.reps || data.reps || 0,
                // have_rom: exercise?.have_rom || data?.have_rom || 0,
                hold_in_seconds: exercise.hold_in_seconds || data.hold_in_seconds || 0,
                target_rom_max: exercise?.target_rom_max || data?.target_rom_max || 100,
                limb_instructions: exercise?.limb_instructions || null,
                set_limb_instruction: exercise?.set_limb_instruction || null,
                is_complete: exercise.is_complete || data.is_complete || 0,
                // is_portrait: exercise.is_portrait || data.is_portrait || 0,
                is_skipped: exercise.is_skipped || data.is_skipped || 0,
                image: exercise.image || data.image || '',
                video: exercise.video || data.video || exercise.videoUrl || '',
                equipment_id: exercise.equipment_id || data.equipment_id || 0,
                equipment_name: exercise.equipment_name || data.equipment_name || ''
            };
        });
    }

    function convertExercisesToActivities(inputExercises, programTaskId = 0) {
        return inputExercises.map((exercise, index) => {
            const data = exercise.exercise_data || {};

            return {
                ...exercise,
                id: Date.now() + index,
                activity_id: exercise.activity_id || exercise.exerciseId || exercise.id || 0, // preserve existing
                display_name: exercise.name || exercise.display_name || data.display_name || '',
                duration: exercise.duration || data.duration || 0,
                duration_type: exercise.duration_type || data.duration_type || 'Reps',
                // rom_minimum: exercise?.rom_minimum || data?.rom_minimum || 0,
                reps: exercise.reps || data.reps || 0,
                // have_rom: exercise?.have_rom || data?.have_rom || 0,
                hold_in_seconds: exercise.hold_in_seconds || data.hold_in_seconds || exercise.hold || 0,
                target_rom_max: exercise?.target_rom_max || data?.target_rom_max || 100,
                limb_instructions: exercise?.limb_instructions,
                set_limb_instruction: exercise?.set_limb_instruction,
                is_complete: exercise.is_complete || data.is_complete || 0,
                // is_portrait: exercise.is_portrait || data.is_portrait || 0,
                is_skipped: exercise.is_skipped || data.is_skipped || 0,
                image: exercise.image || data.image || '',
                video: exercise.video || data.video || exercise.videoUrl || '',
                equipment_id: exercise.equipment_id || data.equipment_id || 0,
                equipment_name: exercise.equipment_name || data.equipment_name || '',
            };
        });
    }

    const calculateDayOffset = (dateStr, startDateStr) => {
        const start = new Date(startDateStr);
        start.setUTCHours(11, 22, 3, 623);
        const target = new Date(dateStr);
        target.setUTCHours(11, 22, 3, 623);
        const diffTime = target - start;
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        return diffDays + 1; // +1 to make it 1-based
    };

    function transformProgramToTaskData(originalProgram) {

        console.log("originalProgram.startDate", originalProgram.startDate)
        const formatDate = (dateStr) => {
            return moment(dateStr).format("M/D/YYYY");
        };

        const formattedStartDate = formatDate(originalProgram.startDate);

        const taskData = [];

        originalProgram.weeks?.forEach((week) => {
            week.days?.forEach((day, dayIndex) => {
                function normalizeDateToMidnightUTC(inputDate) {
                    const date = new Date(inputDate);
                    date.setUTCHours(11, 22, 3, 623);
                    return date.toISOString();
                }

                const tasks_arr = [];

                day.activities?.forEach((activity) => {
                    console.log("activity", activity)
                    const commonTaskFields =
                        !(typeof activity.id === 'string' && activity.id.includes('id_')) ?
                            {
                                suggested_date: normalizeDateToMidnightUTC(day.date).split("T")[0],
                                moved_date: normalizeDateToMidnightUTC(day.date).split("T")[0],
                                is_complete: activity.is_complete ?? 0,
                                is_skipped: activity.is_skipped ?? 0,
                                is_partial: activity.is_partial ?? 0,
                                is_incomplete: activity.is_incomplete ?? 0,
                                task_id: activity.id
                            }
                            :
                            {
                                suggested_date: day.date.split("T")[0].split("T")[0],
                                moved_date: day.date.split("T")[0],
                                is_complete: activity.is_complete ?? 0,
                                is_skipped: activity.is_skipped ?? 0,
                                is_partial: activity.is_partial ?? 0,
                                is_incomplete: activity.is_incomplete ?? 0,
                                task_id: null,
                            }
                        ;

                    if (activity.type === "PT_SESSION") {
                        tasks_arr.push({
                            ...commonTaskFields,
                            duration: activity.duration || activity.estTime || 0,
                            exercise_number: activity.exerciseCount || 0,
                            task_name: activity.name || activity.title || "",
                            type: "PT Session",
                            typeOfTask: "Session",
                            level: activity.level || "",
                            description: activity.description || "",
                            activity_data: activity.activities || convertExercisesToActivities(activity.exercises) || [],
                            rom: activity?.rom ?? 0,
                        });
                    } else if (activity.type === "EDUCATION") {
                        tasks_arr.push({
                            ...commonTaskFields,
                            type: "Education",
                            typeOfTask: "Type",
                            description: activity.description || "",
                            level: activity.level || "",
                            rom: activity.rom || "",
                            education_type: activity.category || "Reading",
                            url: activity.url || "",
                            task_name: activity.title || activity.value || "",
                            duration: activity.duration || 0,
                            rom: activity?.rom ?? 0,
                            activity_data: [],
                            description: "",
                            exercise_number: 0,
                            level: "",
                        });
                    } else if (activity.type === "QUESTIONNAIRE") {
                        tasks_arr.push({
                            ...commonTaskFields,
                            type: "Questionnaire",
                            typeOfTask: "Type",
                            questions_number: activity.questions_number || 0,
                            question_id: activity.question_id || 0,
                            task_name: activity.title || "",
                            rom: activity?.rom ?? 0,
                            activity_data: [],
                            description: "",
                            url: activity.url || "",
                            duration: 0,
                            exercise_number: 0,
                            level: "",
                        });
                    } else if (activity.type === "ROM_TEST") {
                        tasks_arr.push({
                            ...commonTaskFields,
                            type: "Range of Motion Test",
                            typeOfTask: "Session",
                            task_name: activity.title || "",
                            exercise_number: activity.exerciseCount || 0,
                            activity_data: convertSideExercisesToActivities(activity.exercises) || [],
                            description: "",
                            level: "",
                            duration: 0,
                            rom: activity?.rom ?? 0,
                        });
                    }
                });

                if (tasks_arr.length > 0) {
                    taskData.push({
                        // day: taskData.length + 1,
                        day: calculateDayOffset(day.date, originalProgram.startDate),
                        tasks_arr,
                    });
                }
            });
        });


        let returnedObject = {}

        console.log("formattedStartDate", formattedStartDate)

        if (isTemplate) {
            returnedObject = {
                program_id: programId,
                patient_id: 0,
                program_name: originalProgram.programName || "Virdio Health",
                problem_id: originalProgram.problemId,
                sub_problem_id: originalProgram.subtypeId,
                start_date: formattedStartDate,
                taskData,
                program_status: "Unassigned",
                program_weeks: originalProgram.planLength || 1,
                template_id: headerData?.templateId ?? true,
                reward: 0,
                is_template: true,
                clinical_protocol_id: originalProgram?.cpgProtocolId || 0,
                is_in_progress: originalProgram?.is_in_progress || 0
            };
        } else {
            returnedObject = {
                program_id: programId || undefined,
                patient_id: originalProgram.patientId,
                program_name: originalProgram.programName || "Virdio Health",
                problem_id: originalProgram.problemId,
                sub_problem_id: originalProgram.subtypeId,
                start_date: formattedStartDate,
                taskData,
                program_status: headerData?.status,
                program_weeks: originalProgram.planLength || 1,
                template_id: headerData?.saveTemplate ?? false,
                reward: originalProgram?.totalReward,
                clinical_protocol_id: originalProgram?.cpgProtocolId || 0,
                is_in_progress: 0
            };
        }


        console.log(`${isTemplate ? "PROTOCOL" : "PROGRAM"} SUBMIT TRANSFORMED`, returnedObject)
        return returnedObject;
    }


    // ================ RECONVERT DATA BACK TO ORIGNIAL FORMAT =========================

    function calculateProgramLengthFromDayData(programData) {
        if (!programData?.start_date || !Array.isArray(programData.day_data)) {
            return 0;
        }

        const startDate = new Date(programData.start_date);

        const maxDay = Math.max(...programData.day_data.map(day => day.day || 0));

        if (isNaN(maxDay) || maxDay < 1) return 0;

        const lastDayDate = new Date(startDate);
        lastDayDate.setDate(lastDayDate.getDate() + (maxDay - 1)); // day 1 = startDate

        const msInWeek = 7 * 24 * 60 * 60 * 1000;
        const weeks = Math.ceil((lastDayDate - startDate) / msInWeek);

        return weeks;
    }


    function reverseTaskDataToProgram(transformedData, isPropTemplate) {
        console.log(`${isTemplate || isPropTemplate ? "PROTOCOL" : "PROGRAM"} NON TRANSFORMED`, transformedData)
        const realWeeks = calculateProgramLengthFromDayData(transformedData)
        const parseDateToISO = (dateStr) => {
            const date = new Date(dateStr);
            date.setUTCHours(11, 23, 3, 623);
            return date.toISOString();
        };

        const activityTypeMap = {
            "PT Session": "PT_SESSION",
            "Range of Motion Test": "ROM_TEST",
            "Education": "EDUCATION",
            "Questionnaire": "QUESTIONNAIRE",
        };

        // const totalWeeks = realWeeks || transformedData.program_weeks || 1;
        const totalWeeks = realWeeks > transformedData.program_weeks ? realWeeks : transformedData.program_weeks || 1;
        const dayDataMap = new Map();

        // Map day number to taskDay
        transformedData.day_data?.forEach((dayObj) => {
            if (dayObj?.day) {
                dayDataMap.set(dayObj.day, dayObj);
            }
        });

        const weeks = [];

        const originalStart = new Date(transformedData.start_date);
        originalStart.setUTCHours(11, 23, 3, 623);

        // Align base to Monday before/at start_date
        const baseMonday = new Date(originalStart);
        const weekday = baseMonday.getDay(); // 0 (Sun) to 6 (Sat)
        const daysToSubtract = (weekday + 6) % 7; // Sunday -> 6, Monday -> 0, etc.
        baseMonday.setDate(baseMonday.getDate() - daysToSubtract);

        const totalDays = totalWeeks * 7;

        for (let week = 0; week < totalWeeks; week++) {
            const days = [];

            for (let i = 0; i < 7; i++) {
                const currentDate = new Date(baseMonday);
                currentDate.setDate(currentDate.getDate() + (week * 7 + i));
                currentDate.setUTCHours(11, 23, 3, 623);
                const isoDate = currentDate.toISOString();

                // Determine which task day this is (Day 1 = start_date)
                const taskDayIndex = Math.floor((currentDate - originalStart) / (1000 * 60 * 60 * 24)) + 1;
                const taskDay = dayDataMap.get(taskDayIndex > 0 ? taskDayIndex : null);

                const activities = taskDay?.tasks_arr?.map((task) => {
                    const base = {
                        ...task,
                        id: task.task_id,
                        state: "SCHEDULED",
                        type: activityTypeMap[task.type] || "PT_SESSION",
                    };

                    if (task.type === "PT Session") {
                        return {
                            ...base,
                            name: task.task_name,
                            title: task.task_name,
                            description: task.description || "",
                            level: task.level || "",
                            rom: 0,
                            duration: task.duration || 0,
                            task_type: 0,
                            category_type: 0,
                            suggested_date: parseDateToISO(task.suggested_date),
                            program_id: 0,
                            patient_id: transformedData.patient_id,
                            reading_time: 0,
                            copied: 0,
                            original_name: null,
                            completed_date: null,
                            is_template: 1,
                            business_id: 1,
                            company_id: 4,
                            is_favorite: 0,
                            moved_date: null,
                            start_date: null,
                            questionnaire_id: 0,
                            status: 1,
                            problem_id: transformedData.problem_id,
                            total_activities: task.exercise_number || task.activity_data?.length || 0,
                            activities: task.activity_data || [],
                            value: task.task_name,
                            estTime: task.duration || 0,
                            exerciseCount: task.exercise_number || task.activity_data?.length || 0,
                        };
                    }

                    if (task.type === "Range of Motion Test") {
                        console.log("base", base)
                        return {
                            ...base,
                            title: task.task_name,
                            exercises: task.activity_data || [],
                        };
                    }

                    if (task.type === "Education") {
                        return {
                            ...base,
                            title: task.task_name,
                            value: task.task_name,
                            category: task.education_type || "Article",
                            readTime: task.duration || 0,
                            content: "",
                            url: task.url || ""
                        };
                    }

                    if (task.type === "Questionnaire") {
                        return {
                            ...base,
                            title: task.task_name,
                            name: task.task_name,
                            type: "QUESTIONNAIRE",
                            category: "General",
                            questions_number: task.questions_number || 0,
                            questionnaire_id: task.question_id || 0,
                            estTime: 0,
                        };
                    }

                    return base;
                }) || [];

                days.push({
                    id: `id_${Date.now()}_${Math.random().toString(36).substr(2, 10)}`,
                    date: isoDate,
                    activities,
                });
            }

            weeks.push({
                id: `id_${Date.now()}_${Math.random().toString(36).substr(2, 10)}`,
                weekNumber: week + 1,
                days,
            });
        }


        let returnedObject = {}

        console.log("originalStart.toISOString().split(T)[0]", originalStart.toISOString().split("T")[0])

        if (isTemplate || isPropTemplate) {
            returnedObject = {
                patientId: 0,
                patientName: "",
                problemArea: transformedData.problem_name || "",
                problemId: transformedData.problem_id,
                subtype: transformedData.sub_problem_name || "",
                subtypeId: transformedData.sub_problem_id,
                status: transformedData.program_status || "Assigned",
                startDate: originalStart.toISOString().split("T")[0],
                planLength: totalWeeks,
                totalReward: 0,
                weeks,
                programName: transformedData?.program_name,
                templateId: transformedData?.template_id,
                cpgProtocol: transformedData?.clinical_protocol || "",
                cpgProtocolId: transformedData?.clinical_protocol_id || 0,
                is_in_progress: transformedData?.is_in_progress || 0
            };
        } else {
            returnedObject = {
                patientId: transformedData.patient_id,
                patientName: transformedData.patient_name || "",
                problemArea: transformedData.problem_name || "",
                problemId: transformedData.problem_id,
                protocol: "",
                subtype: transformedData.sub_problem_name || "",
                subtypeId: transformedData.sub_problem_id,
                status: transformedData.program_status || "Assigned",
                startDate: originalStart.toISOString().split("T")[0],
                planLength: totalWeeks,
                totalReward: transformedData?.reward,
                weeks,
                programName: transformedData?.program_name,
                cpgProtocol: transformedData?.clinical_protocol || "",
                cpgProtocolId: transformedData?.clinical_protocol_id || 0
            };
        }

        console.log(`${isTemplate || isPropTemplate ? "PROTOCOL" : "PROGRAM"} TRANSFORMED`, returnedObject)

        return returnedObject;
    }

    const [editPtSession, setEditPtSession] = useState(null)
    const [editROMTest, setEditROMTest] = useState(null)

    const handleEditPtSession = (updatedActivity) => {
        console.log("updatedActivity", updatedActivity)
        setPlan((prevPlan) => {
            // Create a deep copy of the plan to avoid direct mutation
            const updatedPlan = { ...prevPlan };

            updatedPlan.weeks = updatedPlan.weeks.map((week) => {
                return {
                    ...week,
                    days: week.days.map((day) => {
                        const updatedActivities = day.activities.map((activity) => {
                            if (activity.id === updatedActivity.id) {
                                return updatedActivity; // Replace with the updated activity
                            }
                            return activity;
                        });

                        return {
                            ...day,
                            activities: updatedActivities,
                        };
                    }),
                };
            });

            return updatedPlan;
        });
        setEditPtSession(null)
    };



    const emptyProgramData = async () => {

        const initialPlanData = {
            weeks: []
        };
        setHeaderData(prev => ({
            ...prev,
            problemArea: '',
            problemId: 0,
            protocol: '',
            subtype: '',
            subtypeId: 0,
            status: 'Unassigned',
            startDate: new Date().toISOString().split('T')[0],
            planLength: 0,
            totalReward: 0,
            programName: "",
            saveTemplate: false
        }))
        setPlan(JSON.parse(JSON.stringify(initialPlanData)));
        setInitialPlan(JSON.parse(JSON.stringify({ ...initialPlanData, ...headerData })));
        setProgramId(undefined)
    }


    // =================== VIEW ONLY MODAL STATES =================

    const [viewPtSession, setViewPtSession] = useState(null)
    const [viewRomTest, setViewRomTest] = useState(null)
    const [showCopyModal, setShowCopyModal] = useState(null);



    return (
        <ProgramContext.Provider value={{
            mockApi,
            ACTIVITY_TYPES,
            ACTIVITY_STATES,
            today,
            checkDataLoaded,
            headerData,
            subProblems,
            plan,
            programId,
            exerciseTemplates,
            editPtSession,
            initialPlan,
            loadingTemplates,
            programTemplates,
            cpgProtocols,
            isTemplate,
            problemAreas,
            viewPtSession,
            viewRomTest,
            editROMTest,
            showCopyModal,
            setShowCopyModal,
            setEditROMTest,
            setViewRomTest,
            setViewPtSession,
            setCpgProtocols,
            setIsTemplate,
            setLoadingTemplates,
            setInitialPlan,
            setEditPtSession,
            setProgramId,
            setPlan,
            setHeaderData,
            ensureDateObject,
            getStartOfWeek,
            addDays,
            formatDate,
            isSameDay,
            isPast,
            generateUniqueId,
            transformProgramToTaskData,
            reverseTaskDataToProgram,
            handleEditPtSession,
            emptyProgramData,
            setSubProblems
        }}>
            {children}
        </ProgramContext.Provider>
    )
}